import React, { useState } from 'react'
import Modal from 'react-bootstrap-modal'
import TextInputWrapper from '../push-notifications/text-input-wrapper'

function GameInvitations({location, onClose, onCreate}) {
  const [title, setTitle] = useState('Hey [Player Name] 👋⚽️')
  const [titleError, setTitleError] = useState(null)
  const [message, setMessage] = useState(`Join us for a game at ${location}!`)
  const [messageError, setMessageError] = useState(null)
  const presenceError = "Can't be blank"


  const onSubmit = (e) => {
    e.preventDefault()

    const [validTitle, validMessage] = [!_.isEmpty(title.trim()), !_.isEmpty(message.trim())]
    validTitle ? setTitleError(null) : setTitleError(presenceError)
    validMessage ? setMessageError(null) : setMessageError(presenceError)

    if (validTitle && validMessage) onCreate({ title: title, message: message })
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose} dialogClassName='push-invites-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Send a game invite</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className='form-horizontal' onSubmit={onSubmit}>
          <TextInputWrapper
            label='Title'
            value={title}
            placeholder='Title'
            onChange={(e) => setTitle(e.target.value)}
            error={titleError}
          />
          <TextInputWrapper
            label='Message'
            value={message}
            placeholder='Message'
            onChange={(e) => setMessage(e.target.value)}
            error={messageError}
          />
          <div className='row'>
            <div className='col-sm-12 text-center'>
              <input type='submit' value='Send' className='btn btn-success' />
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default GameInvitations
